/** FullStory redacts the text/value of anything carrying this class; `FS_UNMASK_CLS` opts a subtree back in. */
export const FS_MASK_CLS = 'fs-mask';
export const FS_UNMASK_CLS = 'fs-unmask';
export const FS_MASK_ATTRS = { className: FS_MASK_CLS };
export const FROZEN_EMPTY_ARRAY = Object.freeze([]);
export const FROZEN_EMPTY_OBJECT = Object.freeze({});
/** Returns a frozen empty array typed as ` T[]`. */
export const getFrozenEmptyArray = () => Object.freeze([]);
/** Returns a frozen empty object typed as `T`. */
export const getFrozenEmptyObject = () => Object.freeze({});
